var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "hl-wid ww1 wh1 wt0 hl-search" },
    [
      _c("div", { staticClass: "logo" }),
      _vm._v(" "),
      _c("vue-autosuggest", {
        attrs: {
          value: _vm.value,
          suggestions: [{ data: _vm.suggestions }],
          "input-props": { id: "autosuggest__input", placeholder: "Search" },
          "get-suggestion-value": _vm.getSuggestionValue
        },
        on: {
          input: function($event) {
            return _vm.$emit("input", $event)
          },
          selected: function($event) {
            return _vm.selectItem($event)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var suggestion = ref.suggestion
              return [
                _c("span", { staticClass: "suggestion-item" }, [
                  _vm._v(_vm._s(_vm.getSuggestionValue(suggestion)))
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }